import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { Loader2, Lock } from "lucide-react";
import { Logo } from "../components/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cardInitial = { opacity: 0, y: 30 };
const cardAnimate = { opacity: 1, y: 0 };
const cardTransition = { duration: 0.6, ease: [0.22, 1, 0.36, 1] };

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      if (res.data.must_change_password) nav("/change-password");
      else if (res.data.role === "packager") nav("/packager");
      else nav("/admin");
    } catch (err) {
      setError(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#052F24] flex items-center justify-center px-5 grain">
      <motion.div
        initial={cardInitial}
        animate={cardAnimate}
        transition={cardTransition}
        className="w-full max-w-md bg-[#F6F5F2] rounded-3xl p-9 sm:p-11"
      >
        <Logo />
        <div className="mt-10 mb-8">
          <span className="inline-flex items-center gap-2 text-[11px] font-bold tracking-[0.2em] uppercase text-[#052F24]/45">
            <Lock size={13} /> Team access
          </span>
          <h1 className="font-display font-extrabold text-3xl tracking-tight mt-3">Team sign in</h1>
        </div>
        <form onSubmit={submit} className="space-y-5">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-white border border-[#E5E5E0] rounded-xl px-4 py-3.5 outline-none focus:border-[#052F24] transition-colors"
            data-testid="login-email"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-white border border-[#E5E5E0] rounded-xl px-4 py-3.5 outline-none focus:border-[#052F24] transition-colors"
            data-testid="login-password"
          />
          {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            className="w-full flex items-center justify-center gap-2 bg-[#052F24] text-[#DFFF00] font-bold py-4 rounded-xl hover:bg-[#0a3d30] transition-colors disabled:opacity-50"
            data-testid="login-submit"
          >
            {loading ? <Loader2 className="animate-spin" size={18} /> : "Sign in"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
